import { Button, ButtonProps } from '@chakra-ui/react';

export default function PillButton({ children, ...rest }: ButtonProps) {
  return (
    <Button
      variant="outline"
      borderColor="border.transparent"
      color="typography.hyperlink"
      _hover={{ bg: 'typography.hyperlink', color: 'white' }}
      size={'sm'}
      borderRadius={'full'}
      {...rest}
    >
      {children}
    </Button>
  );
}
